module.exports = __webpack_public_path__ + "media/br.c834cb5b.svg";